import {
	Links,
	LiveReload,
	Meta,
	Scripts,
	ScrollRestoration,
} from '@remix-run/react';

import { ClientHintCheck } from '#app/utils/client-hints.tsx';

export function Document({
	children,
	nonce,
	theme = 'light',
	env = {},
}: {
	children: React.ReactNode;
	nonce: string;
	theme?: 'dark' | 'light';
	env?: Record<string, string>;
}) {
	return (
		<html lang="de" className={`${theme} h-full`}>
			<head>
				<ClientHintCheck nonce={nonce} />
				<Meta />
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width,initial-scale=1" />
				<Links />
			</head>
			<body className="bg-background text-foreground">
				{children}
				<script
					nonce={nonce}
					dangerouslySetInnerHTML={{
						__html: `window.ENV = ${JSON.stringify(env)}`,
					}}
				/>
				<ScrollRestoration nonce={nonce} />
				<Scripts nonce={nonce} />
				<LiveReload nonce={nonce} />
				{ /* process.env.NODE_ENV === 'production' && (
					<script
						type="text/javascript"
						nonce={nonce}
						dangerouslySetInnerHTML={{
							__html: `
			window._mfq = window._mfq || [];
				(function () {
				var mf = document.createElement("script");
				mf.type = "text/javascript"; mf.defer = true;
				mf.src = "//cdn.mouseflow.com/projects/dbb34fe5-7b90-4ba1-b120-bce7aa61c1da.js";
				document.getElementsByTagName("head")[0].appendChild(mf);})();
			`,
						}}
					></script>
				) */}
			</body>
		</html>
	);
}
